<template>
  <div id="wrapper">
    <!-- Navigation -->
    <nav
      class="navbar navbar-default navbar-static-top"
      role="navigation"
      style="margin-bottom: 0"
    >
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          data-toggle="collapse"
          data-target=".navbar-collapse"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link class="navbar-brand" to="/admin"
          ><i class="fa fa-globe fa-fw text-danger"></i>Passaport</router-link
        >
      </div>
      <!-- /.navbar-header -->
      <ul class="nav navbar-top-links navbar-right">
       
        <li class="dropdown">
          <a class="dropdown-toggle" data-toggle="dropdown" href="#">
            <i class="fa fa-user fa-fw"></i> <i class="fa fa-caret-down"></i>
            {{ user.email }} ({{ profileName }})
          </a>
          <ul class="dropdown-menu dropdown-user">
            <li>
              <router-link to="/admin/my-profile"
                ><i class="fa fa-user fa-fw"></i> Perfil</router-link
              >
            </li>
            <li class="divider"></li>
            <li>
              <router-link to="/logout">
                <i class="fa fa-sign-out fa-fw"></i> Sair
              </router-link>
            </li>
          </ul>
          <!-- /.dropdown-user -->
        </li>
        <!-- /.dropdown -->
      </ul>
      <!-- /.navbar-top-links -->

      <div v-if="isAdmin" class="navbar-default sidebar" role="navigation">
        <div class="sidebar-nav navbar-collapse">
          <ul class="nav" id="side-menu">
           
            <li>
              <router-link to="#">
                <i class="fa fa-dashboard fa-fw"></i> Dashboard
              </router-link>
              <ul class="nav nav-second-level">
                <li>
                  <router-link to="/admin"> <i class="fa fa-dashboard fa-fw"></i> Credenciamento </router-link>
                </li>
                <li>
                  <router-link to="/admin/routines-dashboard"> <i class="fa fa-dashboard fa-fw"></i> Rotinas </router-link>
                </li>
              </ul>
            </li>

            <li>
              <router-link to="#">
                <i class="fa fa-cogs fa-fw"></i> Parametrizações
              </router-link>
              <ul class="nav nav-second-level">
                <li>
                  <router-link to="/admin/locations"
                    ><i class="fa fa-map-marker" aria-hidden="true"></i>
                    Locais</router-link
                  >
                </li>
                <li>
                  <router-link to="/admin/activity">
                    <i class="fa fa-rocket fa-fw"></i> Atividades
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/routines">
                    <i class="fa fa-tags" aria-hidden="true"></i> Rotinas
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/persons">
                    <i class="fa fa-building fa-fw"></i> Empresas
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/sectors">
                    <i class="fa fa-codepen fa-fw"></i> Setores
                  </router-link>
                </li>
                <li>
                    <router-link to="/admin/document-types">
                        <i class="fa fa-file-text" aria-hidden="true"></i> Tipos de Documentos
                    </router-link>
                </li>
              </ul>
            </li>

            <li>
              <router-link to="#">
                <i class="fa fa-file-text fa-fw"></i> Credenciamento
              </router-link>
              <ul class="nav nav-second-level">
                <li>
                  <router-link to="/admin/certificates">
                    <i class="fa fa-certificate fa-fw"></i> Certificados
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/emit-certificate">
                    <i class="fa fa-file-pdf-o fa-fw"></i> Emissão de
                    Certificados
                  </router-link>
                </li>
              </ul>
            </li>

            <li>
              <router-link to="#">
                <i class="fa fa-tasks fa-fw"></i> Rotinas
              </router-link>
              <ul class="nav nav-second-level">
                <li>
                  <router-link to="/admin/routine-solicitation">
                    <i class="fa fa-circle-o-notch fa-fw"></i> Solicitação de
                    Rotinas
                  </router-link>
                </li>
              </ul>
            </li>

            <li>
              <router-link to="#">
                <i class="fa fa-square fa-fw"></i> Admin
              </router-link>
              <ul class="nav nav-second-level">
                <li>
                  <router-link to="/admin/configurations">
                    <i class="fa fa-cogs fa-fw"></i> Configurações
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/users">
                    <i class="fa fa-users fa-fw"></i> Usuários
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/perfil">
                    <i class="fa fa-shield fa-fw"></i> Perfis
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/about">
                    <i class="fa fa-info fa-fw"></i> Sobre
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <!-- /.sidebar-collapse -->
      </div>
      <div v-else class="navbar-default sidebar" role="navigation">
        <div class="sidebar-nav navbar-collapse">
          <ul class="nav" id="side-menu">
            <li>
              <router-link to="/admin">
                <i class="fa fa-dashboard fa-fw"></i> Dashboard
              </router-link>
            </li>
            <li>
              <router-link to="/admin/my-persons">
                <i class="fa fa-building fa-fw"></i> Minhas Empresas
              </router-link>
            </li>
            <li>
              <router-link to="/admin/about">
                <i class="fa fa-info fa-fw"></i> Sobre</router-link
              >
            </li>
          </ul>
        </div>
        <!-- /.sidebar-collapse -->
      </div>
      <!-- /.navbar-static-side -->
    </nav>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import storage from "../mixins/storage";

export default {
  name: "Home",
  data() {
    return {
      user: {},
      profileName: null,
      isAdmin: null,
      profilesNames: { ROLE_ADMIN: "admin", ROLE_USER: "padrão" },
    };
  },
  mounted() {
    this.user = storage.methods.getUser();
    this.isAdmin = storage.methods.isAdmin();
    this.profileName = this.profilesNames[this.user.profiles[0].name];
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue